import React, {useContext} from "react"
import FirstQuiz from "./quizSteps/FirstQuiz"
import {QuizzContext} from "../../../context/QuizzContext"
import SecondQuiz from "./quizSteps/SecondQuizz"
import ThirdQuiz from "./quizSteps/ThirdQuiz"
import FourthQuiz from "./quizSteps/FourthQuiz"
import FithQuiz from "./quizSteps/FithQuiz"
import Typography from "../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import Spinner from "../../reusable/Spinner"
import QuizForm from "./quizSteps/QuizForm"
import QuizzSubmitSuccess from "./quizSteps/QuizzSubmitSuccess"

function SuggestionQuiz() {
	const rows = Array.from({length: 7}, () => Array(5).fill(0))
	const {activeQuizz, totalNumberOfProducts, isLoadingProductsCount} = useContext(QuizzContext)
	const {t} = useTranslation()
	const renderQuiz = {
		0: <FirstQuiz />,
		1: <SecondQuiz />,
		2: <ThirdQuiz />,
		3: <FourthQuiz />,
		4: <FithQuiz />,
		5: <QuizForm />,
		6: <QuizzSubmitSuccess />
	}
	return (
		<div className="quiz-container">
			{activeQuizz < 6 ? <div className="d-flex align-items-start justify-content-start col-12 flex-column"
				style={{gap: "8px"}}>
				<div className="d-flex gap-1 col-12 align-items-center justify-content-evenly">
					{rows.map((row, index) => <div className={`quiz-indicator ${activeQuizz >= index ? "active" : ""}`}
						key={index} />)}</div>
				{isLoadingProductsCount ? <Typography style={{fontSize: "14px", lineHeight: "20px"}}
					variant="bodySm"
					className="d-flex text-secondary align-items-center justify-content-start gap-2 col-12"> <Spinner color="secondary"
						size="sm"/> {t("products-found")}</Typography> : <Typography style={{fontSize: "14px", lineHeight: "20px"}}
					variant="bodySm"
					className="d-flex position-relative text-secondary align-items-center justify-content-start col-12">
					{totalNumberOfProducts + " " + t("products-found")}</Typography>}
			</div> : null}
			{renderQuiz[activeQuizz]}
		</div>
	)
}

export default SuggestionQuiz
